import { useQuery } from '@tanstack/react-query';

import type { ProductWebinarDetails } from '~/routes/__loaders/product_webinar_details';

export const webinarDetailsKeys = {
  all: ['webinar-details'] as const,
  bySlug: (slug: string) => ['webinar-details', slug] as const,
};

const fetchWebinarDetails = async (slug: string): Promise<ProductWebinarDetails> => {
  const response = await fetch(`/product_webinar_details?slug=${encodeURIComponent(slug)}`);
  if (!response.ok) throw new Error('Failed to fetch webinar details');
  return response.json();
};

interface Props {
  slug: string;
  enabled?: boolean;
}

const useWebinarDetails = ({ slug, enabled = true }: Props) => {
  return useQuery({
    queryKey: webinarDetailsKeys.bySlug(slug),
    queryFn: () => fetchWebinarDetails(slug),
    enabled: enabled && !!slug,
    staleTime: 30_000,
  });
};

export default useWebinarDetails;
